/* eslint-disable no-prototype-builtins */
import Big from 'big.js'
import dayjs from '@/helpers/dayjs'

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
export function find(list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
export function deepCopy(obj, cache = []) {
  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  const hit = find(cache, (c) => c.original === obj)
  if (hit) {
    return hit.copy
  }

  const copy = Array.isArray(obj) ? [] : {}
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy,
  })

  Object.keys(obj).forEach((key) => {
    copy[key] = deepCopy(obj[key], cache)
  })

  return copy
}

/**
 * forEach for object
 */
export function forEachValue(obj, fn) {
  Object.keys(obj).forEach((key) => fn(obj[key], key))
}

export function isObject(obj) {
  return obj !== null && typeof obj === 'object'
}

export function isPromise(val) {
  return val && typeof val.then === 'function'
}

export function assert(condition, msg) {
  if (!condition) throw new Error(`[vuex] ${msg}`)
}

export function partial(fn, arg) {
  return function () {
    return fn(arg)
  }
}

export function snakeCase(val) {
  if (val)
    return val
      .split(/(?=[A-Z])/)
      .join('_')
      .toLowerCase()
  return null
}

export function makeId(length) {
  var result = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(
      Math.floor(Math.random() * charactersLength),
    )
  }
  return result
}

/**
 * Convert Satang to Baht
 * @param {Number|String} value Satang
 * @returns {String} Baht
 */
export const convertSatangToBaht = (value) => {
  return new Big(value).div(100).toNumber()
}

/**
 * Convert Baht to Satang
 * @param {Number|String} value Baht
 * @returns {String} Satang
 */
export const convertBahtToSatang = (value = 0) => {
  return new Big(value).times(100).toNumber()
}

/**
 * Format the price value
 * @param {Number|String} price Price in Satang
 */
export const priceFormat = (price = 0) => {
  const satangPrice = new Big(price)

  let localeStringOptions = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }

  return `฿${Number(satangPrice).toLocaleString(
    undefined,
    localeStringOptions,
  )}`
}

/**
 * Format the discounted price value
 * @param {Number|String} price Price in Satang
 */
export const discountedPriceFormat = (price = 0) => {
  return `- ${priceFormat(price)}`
}

/**
 * Format number with separator 1000 -> 1,000
 * @param {Number|String} number
 */
export const numberFormat = (number = 0) => {
  return new Intl.NumberFormat('th-TH').format(number)
}

/**
 * Convert number to positive value only
 * @param {Number} number
 * @returns {Number} If the argument is negative, returns 0. Otherwise, return argument.
 */
export const positiveOnly = (number) => {
  if (isNaN(number)) {
    return NaN
  }
  if (number < 0) {
    return 0
  }
  return number
}

/**
 *
 * @param {Date} start
 * @param {Date} end
 * @returns {Number}
 */
export const diffDays = (start, end) => {
  const date1 = dayjs(start)
  const date2 = dayjs(end)

  let hours = date2.diff(date1, 'hours')
  const days = Math.floor(hours / 24)
  return days
}

export const serialize = (obj) => {
  let str = []
  for (let p in obj)
    if (obj.hasOwnProperty(p) && obj[p]) {
      str.push(
        encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]),
      )
    }
  return str.join('&')
}

export const formatDateTh = (date) => {
  return dayjs(date).format('DD/MM/YYYY HH:mm')
}

export const diffDate = (date) => {
  const diff = dayjs()

  let hours = diff.diff(date, 'hours')
  const days = Math.floor(hours / 24)

  return days
}
